export default __webpack_public_path__ + "static/media/srl-telematics.4ce0649a.png";